var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic / close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5859 11.7071L4.29297 5.41421L5.70718 4L12.0001 10.2929L18.293 4L19.7072 5.41421L13.4143 11.7071L19.7072 18L18.293 19.4142L12.0001 13.1213L5.70718 19.4142L4.29297 18L10.5859 11.7071Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6cee2ab3ccc2b49fb39fa042d8e62da9.svg";
export { ForwardRef as ReactComponent };